import { get, post } from '../../utils/http'

const user_detail = JSON.parse(localStorage.getItem('user_detail')) || {user_id: 0};
const provinceId = JSON.parse(localStorage.getItem('provinceId')) || 0;
const year = JSON.parse(localStorage.getItem('year')) || 0;

export const getRecommendation = (codes) => post(`/xbag/college/specialty/gets`, { _s_codes: codes || '', limit: 9999,_s_gk_province_id:provinceId, _s_gk_year:year }, false);//根据code码查专业列表 查询专业信

export const saveSpecialtyIntention = (ids,type) => post(`/xbag/college/intention/specialty/save/${ids.join(',')}?user_id=${Number(user_detail.student.userId)}&type=${type||1}`, {});//保存意向专业

export const clearSpecialtyIntention = () => post(`/xbag/college/purpose/specialty/clear?user_id=${Number(user_detail.student.userId)}`, {})

export const recommendSpecialty = () => get(`/sjsy/api/recommend/hld/specialty`, {});//重置专业至hld推荐专业

export const getXkCoachBasic = () => get(`/sjsy/api/xk_coach/basic/get`, {});//获取选科报告基本信息

export const saveXkCoachBasic = (provinceId,year,status) => post(`/sjsy/api/xk_coach/basic/save`, {provinceId,year,status});//更新选科辅导状态





// WEBPACK FOOTER //
// ./src/api/majorWishList/index.js